import { useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { useQuery, useApolloClient } from '@apollo/client'

import { TabsWrapper, Tabs, Tab } from 'components/Tabs'
import { ORDER_STATUS } from 'features/Inventories/components/OrderStatus/constants'
import { resolvers as ordersResolvers, GET_PENDING_ORDERS_COUNT } from 'resolvers/orders'

export const CartTabs = ({ cartId }: TSFixMe): TSFixMe => {
  const client = useApolloClient()
  client.addResolvers(ordersResolvers)

  const { data = {}, refetch } = useQuery(GET_PENDING_ORDERS_COUNT, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      limit: 100000,
      page: 1,
      inventoryId: cartId,
      status: ORDER_STATUS.PENDING
    }
  })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  return (
    <TabsWrapper>
      <Tabs>
        <Tab as={NavLink} to={`/carts/${cartId}/items`}>
          <FormattedMessage id="spanish.carts.tabs.items" defaultMessage="Inventario" />
        </Tab>

        <Tab as={NavLink} to={`/carts/${cartId}/activity`}>
          <FormattedMessage id="spanish.carts.tabs.activity" defaultMessage="Actividad" />
        </Tab>

        <Tab as={NavLink} to={`/carts/${cartId}/inbound-orders`}>
          <FormattedMessage id="spanish.carts.tabs.inbounds" defaultMessage="Entradas" />
        </Tab>

        <Tab as={NavLink} to={`/carts/${cartId}/outbound-orders`}>
          <FormattedMessage id="spanish.carts.tabs.outbounds" defaultMessage="Salidas" />
        </Tab>

        <Tab as={NavLink} to={`/carts/${cartId}/pending-orders`}>
          <FormattedMessage
            id="spanish.carts.tabs.pendingOrders"
            defaultMessage="Pendientes ({pendingOrdersCount})"
            values={{
              pendingOrdersCount: (data && data.orders && data.orders.total) || 0
            }}
          />
        </Tab>

        <Tab as={NavLink} to={`/carts/${cartId}/wastes`}>
          <FormattedMessage id="spanish.carts.tabs.wastes" defaultMessage="Merma" />
        </Tab>
      </Tabs>
    </TabsWrapper>
  )
}
